module.exports = "<input type=\"checkbox\"\n       ng-model=\"$ctrl.value\"\n       id=\"{{$ctrl.componentId}}\"\n       ng-change=\"$ctrl.changeValue()\"\n       class=\"frCheckbox__input\">\n<label for=\"{{$ctrl.componentId}}\" ng-if=\"$ctrl.label\">\n    {{$ctrl.label}}\n</label>"


//////////////////
// WEBPACK FOOTER
// ./~/@front10/healthcare-book/src/app/common/checkbox/checkbox.html
// module id = 583
// module chunks = 0